module.exports = new __parcel__URL__("Druideskill_07.d63ed4e9.png").toString();